
<template>
<div class="flex w-full h-full justify-center items-center bg-card-secondary">
    <UICard class="p-8 max-w-lg mx-auto flex items-center justify-center w-full">
        <div class="flex flex-col items-center justify-center text-center">
            <h1 v-if="error?.statusCode === 403 || error?.statusCode === 401" class="text-2xl font-bold text-red-500 mb-4">Access Denied</h1>
            <p v-if="error?.statusMessage" class="text-text-secondary">{{ error?.statusMessage }}</p>
        </div>

    </UICard>
</div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

interface Props {
  error?: NuxtError
}

const props = defineProps<Props>()
const router = useRouter()
const handleError = () => clearError({ redirect: '/' })
</script>
